/* global AbortController */
import { unAuthorizedToken } from '../utils/Validations'
import { fetchWithTimeout } from './apiTimeoutHelper';
import { getAuthToken } from './authHelper';
const server_address = process.env.REACT_APP_SERVER_ADDRESS;

const selected_city = localStorage.getItem('selected_city')? localStorage.getItem('selected_city') : ''

export const getVendors = (userCity) => {
  return fetch(`${server_address}/api/v1/vendors/autosuggest/approved-vendors?userCity=${userCity}`, {
    headers: new Headers({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${getAuthToken()}`
    }),
    method: 'GET'
  }).then((res) => {
     if (res.status === 401) {
      unAuthorizedToken()
    }
    else {
      return res.json()
    }
  })
}

export const getPOnumbers = (vendor_code, type_of_payment) => {
  return fetch(`${server_address}/api/v1/payments/get/po-numbers?vendor_code=${vendor_code}&type_of_payment=${encodeURIComponent(type_of_payment)}`, {
    headers: new Headers({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${getAuthToken()}`
    }),
    method: 'GET'
  }).then((res) => {
     if (res.status === 401) {
      unAuthorizedToken()
    }
    else {
      return res.json()
    }
  })
}

export const calculateAdvancePaid = (po_number, vendor_code) => {
  return fetch(`${server_address}/api/v1/payments/calculate-advance?po_number=${encodeURIComponent(po_number)}&vendor_code=${vendor_code}`, {
    headers: new Headers({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${getAuthToken()}`
    }),
    method: 'GET'
  }).then((res) => {
     if (res.status === 401) {
      unAuthorizedToken()
    }
    else {
      return res.json()
    }
  })
}

export const fetchBuList = () => {
  return fetch(`${server_address}/api/v1/payments/buList`, {
    headers: new Headers({
      'Authorization': `Bearer ${getAuthToken()}`
    }),
    method: 'GET'
  }).then((res) => {
      if (res.status === 401) {
      unAuthorizedToken()
    }
    else {
      return res.json()
    }
  })
}

export const onboardPaymentRequest = (body) => {
  return fetch(`${server_address}/api/v1/payments/request/payment`, {
    headers: new Headers({
      'Authorization': `Bearer ${getAuthToken()}`
    }),
    body: body,
    method: 'POST'
  }).then((res) => {
     if (res.status === 401) {
      unAuthorizedToken()
    }
    else {
      return res.json()
    }
  })
}

export const createBulkPaymentRequests = (body) => {
  return fetch(`${server_address}/api/v1/payments/request/payment/createBulk`, {
    headers: new Headers({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${getAuthToken()}`
    }),
    body: body,
    method: 'POST'
  }).then((res) => {
     if (res.status === 401) {
      unAuthorizedToken()
    }
    else {
      return res.json()
    }
  })
}

export const getPaymentStatus = (filters) => {
  let urlEndPoint = `${server_address}/api/v1/payments/status`;
  if(filters && filters.from_date && filters.to_date){
    urlEndPoint += `?from_date=${filters.from_date}&to_date=${filters.to_date}&city=${selected_city}`
  }
  //failed state filter
  else if(filters && filters.state){
    urlEndPoint += `?state=${filters.state}&city=${selected_city}`
  }
  else
    urlEndPoint += `?city=${selected_city}`

  return fetchWithTimeout(urlEndPoint, {
    headers: new Headers({
      'Authorization': `Bearer ${getAuthToken()}`
    }),
    method: 'GET',
  }, 5 * 60 * 1000).then((res) => {
    if (res.status === 401) {
      unAuthorizedToken()
    }
    else {
      return res.json()
    }
  }).catch((error) => {
    if (error.message === 'timeout') {
        error.message = 'Something went wrong. Please try again later.'
    }
    throw error;
  });
}

export const getPaymentsReport = (filters) => {
  const isAllCities = selected_city === 'all_cities';
  let urlEndPoint = `${server_address}/api/v1/payments/getPaymentsReport`;
  if(!isAllCities){
    urlEndPoint += `?city=${selected_city}`
  }
  if(filters && filters.from_date && filters.to_date){
    urlEndPoint += `${!isAllCities ? '&' : '?'}from_date=${filters.from_date}&to_date=${filters.to_date}`
  }
  return fetch(urlEndPoint , {
    headers: new Headers({
      'Authorization': `Bearer ${getAuthToken()}`
    }),
    method: 'GET'
  }).then((res) => {
    if (res.status === 401) {
      unAuthorizedToken()
    }
    else {
      return res.json()
    }
  })
}

export const getAccountingReport = (filters) => {
  const isAllCities = selected_city === 'all_cities';
  let urlEndPoint = `${server_address}/api/v1/payments/getAccountingReport`;
  if(!isAllCities){
    urlEndPoint += `?city=${selected_city}`
  }
  if(filters && filters.from_date && filters.to_date){
    urlEndPoint += `${!isAllCities ? '&' : '?'}from_date=${filters.from_date}&to_date=${filters.to_date}`
  }
  return fetch(urlEndPoint , {
    headers: new Headers({
      'Authorization': `Bearer ${getAuthToken()}`
    }),
    method: 'GET'
  }).then((res) => {
    if (res.status === 401) {
      unAuthorizedToken()
    }
    else {
      return res.json()
    }
  })
}

export const getBillSubmissionReport = (filters) => {
  const isAllCities = selected_city === 'all_cities';
  let urlEndPoint = `${server_address}/api/v1/payments/getBillSubmissionReport`;
  if(!isAllCities){
    urlEndPoint += `?city=${selected_city}`
  }
  if(filters && filters.from_date && filters.to_date){
    urlEndPoint += `${!isAllCities ? '&' : '?'}from_date=${filters.from_date}&to_date=${filters.to_date}`
  }
  return fetch(urlEndPoint , {
    headers: new Headers({
      'Authorization': `Bearer ${getAuthToken()}`
    }),
    method: 'GET'
  }).then((res) => {
    if (res.status === 401) {
      unAuthorizedToken()
    }
    else {
      return res.json()
    }
  })
}

export const getExcelUploadReport = (filters, signal) => {
  const isAllCities = selected_city === 'all_cities';
  let urlEndPoint = `${server_address}/api/v1/tally/excelUploadReport`;
  if(!isAllCities){
    urlEndPoint += `?city=${selected_city}`
  }
  if(filters && filters.from_date && filters.to_date){
    urlEndPoint += `${!isAllCities ? '&' : '?'}from_date=${filters.from_date}&to_date=${filters.to_date}&view=${filters.view}`
  }

  // Create a timeout abort controller (5 minutes) if no external signal provided
  const timeoutController = new AbortController();
  const timeoutId = setTimeout(() => timeoutController.abort(), 5 * 60 * 1000);

  // If an external signal is provided, listen for its abort and chain it
  if (signal) {
    signal.addEventListener('abort', () => timeoutController.abort());
  }

  return fetch(urlEndPoint , {
    headers: new Headers({
      'Authorization': `Bearer ${getAuthToken()}`
    }),
    method: 'GET',
    signal: timeoutController.signal
  }).then((res) => {
    clearTimeout(timeoutId);
    if (res.status === 401) {
      unAuthorizedToken()
    }
    else {
      return res.json()
    }
  }).catch((err) => {
    clearTimeout(timeoutId);
    if (err.name === 'AbortError') {
      return { status: 'cancelled', message: 'Request was cancelled or timed out' };
    }
    return { status: 'error', message: 'Network error. Please try again.' };
  })
}

export const getBillSubmissionPaymentRequest = (filters) => {
  let urlEndPoint = `${server_address}/api/v1/payments/getBillSubmissionDataByIds`;
  if(filters && filters.bill_submission_ids){
    urlEndPoint += `?bill_submission_ids=${filters.bill_submission_ids}`
  }
  return fetch(urlEndPoint , {
    method: 'GET'
  }).then((res) => {
    return res.json()
  })
}

export const getLedgerBasedBillingReport = (filters) => {
  let urlEndPoint = `${server_address}/api/v1/payments/getLedgerBasedBillingReport`;
  if(filters && filters.from_date && filters.to_date){
    urlEndPoint += `?from_date=${filters.from_date}&to_date=${filters.to_date}`
  }
  return fetch(urlEndPoint , {
    headers: new Headers({
      'Authorization': `Bearer ${getAuthToken()}`
    }),
    method: 'GET'
  }).then((res) => {
    if (res.status === 401) {
      unAuthorizedToken()
    }
    else {
      return res.json()
    }
  })
}

export const getCostOwnerCenterReport = (filters = {}) => {
  let urlEndPoint = `${server_address}/api/v1/payments/getCostOwnerCenterReport`;
  const params = new URLSearchParams();

  if (filters.from_date) params.append('from_date', filters.from_date);
  if (filters.to_date) params.append('to_date', filters.to_date);
  if (filters.center_ids) params.append('center_ids', filters.center_ids);

  if (params.toString()) {
    urlEndPoint += `?${params.toString()}`;
  }

  return fetch(urlEndPoint, {
    headers: new Headers({
      'Authorization': `Bearer ${getAuthToken()}`
    }),
    method: 'GET'
  }).then((res) => {
    if (res.status === 401) {
      unAuthorizedToken()
    }
    else {
      return res.json()
    }
  })
}

export const uploadPaymentStatus = (body) => {
  return fetch(`${server_address}/api/v1/payments/status`, {
    headers: new Headers({
      'Authorization': `Bearer ${getAuthToken()}`
    }),
    body: body,
    method: 'POST'
  }).then((res) => {
    if (res.status === 401) {
      unAuthorizedToken()
    }
    else {
      return res.json()
    }
  })
}

export const uploadPaymentRequest = (body, req_city) => {
  return fetch(`${server_address}/api/v1/payments/request/upload/new?requesterCity=${req_city}`, {
    headers: new Headers({
      'Authorization': `Bearer ${getAuthToken()}`
    }),
    body: body,
    method: 'POST'
  }).then((res) => {
    if (res.status === 401) {
      unAuthorizedToken()
    }
    else {
      return res.json()
    }
  })
}

export const updatePaymentRequest = (body) => {
  return fetch(`${server_address}/api/v1/payments/update/pending-request`, {
    headers: new Headers({
      'Authorization': `Bearer ${getAuthToken()}`
    }),
    body: body,
    method: 'POST'
  }).then((res) => {
     if (res.status === 401) {
      unAuthorizedToken()
    }
    else {
      return res.json()
    }
  })
}

export const approvePaymentRequest = (body) => {
  return fetch(`${server_address}/api/v1/payments/approve/payment-request`, {
    headers: new Headers({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${getAuthToken()}`
    }),
    body: body,
    method: 'POST'
  }).then((res) => {
     if (res.status === 401) {
      unAuthorizedToken()
    }
    else {
      return res.json()
    }
  })
}

export const rejectPaymentRequest = (body) => {
  return fetch(`${server_address}/api/v1/payments/reject/payment-request`, {
    headers: new Headers({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${getAuthToken()}`
    }),
    body: body,
    method: 'POST'
  }).then((res) => {
     if (res.status === 401) {
      unAuthorizedToken()
    }
    else {
      return res.json()
    }
  })
}

export const getEntities = (userCity) => {
  return fetch(`${server_address}/api/v1/payments/autosuggest/entities?userCity=${userCity}`, {
    headers: new Headers({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${getAuthToken()}`
    }),
    method: 'GET'
  }).then((res) => {
     if (res.status === 401) {
      unAuthorizedToken()
    }
    else {
      return res.json()
    }
  })
}

export const getPendingPayments = (body) => {
  let selected_city = localStorage.getItem('selected_city')?`?city=${localStorage.getItem('selected_city')}`:''
  return fetch(`${server_address}/api/v1/payments/get/approved-requests` + selected_city, {
    headers: new Headers({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${getAuthToken()}`
    }),
    body: body,
    method: 'POST'
  }).then((res) => {
     if (res.status === 401) {
      unAuthorizedToken()
    }
    else {
      return res.json()
    }
  })
}

export const getVendorTdsRate = async (vendorCode, ledgerId) => {
  return fetch(`${server_address}/api/v1/payments/get/vendor/${vendorCode}/tds-rate?ledgerId=${ledgerId}`, {
    headers: new Headers({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${getAuthToken()}`
    }),
    method: 'GET'
  }).then((res) => {
    if (res.status === 401) {
      unAuthorizedToken()
    }
    else {
      return res.json()
    }
  })
}

export const updateInvoiceAmount = async (paymentReqId, invoiceAmount) => {
  return fetch(`${server_address}/api/v1/payments/update/${paymentReqId}/invoiceAmt`, {
    headers: new Headers({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${getAuthToken()}`,
    }),
    body: JSON.stringify({invoiceAmount}),
    method: 'PUT'
  }).then((res) => {
    if (res.status === 401) {
      unAuthorizedToken()
    }
    else {
      return res.json()
    }
  })
}

export const getProcessedPayments = (body) => {
  let selected_city = localStorage.getItem('selected_city')?`?city=${localStorage.getItem('selected_city')}`:''
  return fetch(`${server_address}/api/v1/payments/get/processed-payments` + selected_city, {
    headers: new Headers({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${getAuthToken()}`
    }),
    body: body,
    method: 'POST'
  }).then((res) => {
     if (res.status === 401) {
      unAuthorizedToken()
    }
    else {
      return res.json()
    }
  })
}

export const changeProcessedPaymentStatus = async (body) => {
  try {
    const res = await fetch(`${server_address}/api/v1/payments/change/processed-payment-status`, {
      headers: new Headers({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${getAuthToken()}`
      }),
      body: body,
      method: 'POST'
    });

    if (res.status === 401) {
      unAuthorizedToken()
    } else {
      return res.json()
    }
  } catch (error) {
    console.error('Error changing processed payment status:', error);
    throw error;
  }
}

export const getApprovingPayments = (body) => {
  let selected_city = localStorage.getItem('selected_city')?`?city=${localStorage.getItem('selected_city')}`:''
  return fetch(`${server_address}/api/v1/payments/get/pending-requests` + selected_city, {
    headers: new Headers({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${getAuthToken()}`
    }),
    body: body,
    method: 'POST'
  }).then((res) => {
     if (res.status === 401) {
      unAuthorizedToken()
    }
    else {
      return res.json()
    }
  })
}

export const deletePendingPayment = (body) => {
  return fetch(`${server_address}/api/v1/payments/delete/pending-request`, {
    headers: new Headers({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${getAuthToken()}`
    }),
    body: body,
    method: 'POST'
  }).then((res) => {
     if (res.status === 401) {
      unAuthorizedToken()
    }
    else {
      return res.json()
    }
  })
}

export const intializePayments = (body) => {
  return fetch(`${server_address}/api/v1/payments/init`, {
    headers: new Headers({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${getAuthToken()}`
    }),
    body: body,
    method: 'POST'
  }).then((res) => {
     if (res.status === 401) {
      unAuthorizedToken()
    }
    else {
      return res.json()
    }
  })
}

export const getBankUploadedDetails = (fromDate, toDate) => {
  let selected_city = localStorage.getItem('selected_city')?`city=${localStorage.getItem('selected_city')}`:''
  let urlEndPoint = `${server_address}/api/v1/payments/bank-uploads`;
  if(fromDate && toDate){
    urlEndPoint += `?from_date=${fromDate}&upto_date=${toDate}` + `&${selected_city}`
  }
  else
    urlEndPoint += `?${selected_city}`
  return fetch(urlEndPoint, {
    headers: new Headers({
      'Authorization': `Bearer ${getAuthToken()}`,
    }),
    method: 'GET'
  }).then((res) => {
     if (res.status === 401) {
      unAuthorizedToken()
    }
    else {
      return res.json()
    }
  })
}

export const generateOtp = (body) => {
  return fetch(`${server_address}/users/otp`, {
    headers: new Headers({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${getAuthToken()}`
    }),
    body: body,
    method: 'POST'
  }).then((res) => {
     if (res.status === 401) {
      unAuthorizedToken()
    }
    else {
      return res.json()
    }
  })
}

export const forgetPassword = (body) => {
  return fetch(`${server_address}/users/password`, {
    headers: new Headers({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${getAuthToken()}`
    }),
    body: body,
    method: 'PUT'
  }).then((res) => {
     if (res.status === 401) {
      unAuthorizedToken()
    }
    else {
      return res.json()
    }
  })
}
export const updatePassword = (body) => {
  return fetch(`${server_address}/users/password/update`, {
    headers: new Headers({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${getAuthToken()}`
    }),
    body: body,
    method: 'PUT'
  }).then((res) => {
     if (res.status === 401) {
      unAuthorizedToken()
    }
    else {
      return res.json()
    }
  })
}
export const validatePaymentRequest = (vendor_code, invoice_number, date_of_invoice) => {
  const url = date_of_invoice ? 
    `${server_address}/api/v1/payments/validate?vendor_code=${vendor_code}&invoice_number=${encodeURIComponent(invoice_number)}&date_of_invoice=${date_of_invoice}` 
    : `${server_address}/api/v1/payments/validate?vendor_code=${vendor_code}&invoice_number=${encodeURIComponent(invoice_number)}`;
    
  return fetch(url, {
    headers: new Headers({
      'Authorization': `Bearer ${getAuthToken()}`
    }),
    method: 'GET'
  }).then((res) => {
     if (res.status === 401) {
      unAuthorizedToken()
    }
    else {
      return res.json()
    }
  })
}

export const validatePaymentRequestWhileCreation = (vendor_code, invoice_number, date_of_invoice) => {
  return fetch(`${server_address}/api/v1/payments/validate-creation?vendor_code=${vendor_code}&invoice_number=${encodeURIComponent(invoice_number)}&date_of_invoice=${date_of_invoice}`, {
    headers: new Headers({
      'Authorization': `Bearer ${getAuthToken()}`
    }),
    method: 'GET'
  }).then((res) => {
     if (res.status === 401) {
      unAuthorizedToken()
    }
    else {
      return res.json()
    }
  })
}

export const getProhibitedPONumbers = (vendor_code) => {
  return fetch(`${server_address}/api/v1/payments/getProhibitedPONumbers?vendor_code=${vendor_code}`, {
    headers: new Headers({
      'Authorization': `Bearer ${getAuthToken()}`
    }),
    method: 'GET'
  }).then((res) => {
     if (res.status === 401) {
      unAuthorizedToken()
    }
    else {
      return res.json()
    }
  })
}

export const getCostCenters = () => {
  let selected_city = localStorage.getItem('selected_city')?`?city=${localStorage.getItem('selected_city')}`:''
  return fetch(`${server_address}/api/v1/cost-center/view` + selected_city, {
    headers: new Headers({
      'Authorization': `Bearer ${getAuthToken()}`
    }),
    method: 'GET'
  }).then((res) => {
     if (res.status === 401) {
      unAuthorizedToken()
    }
    else {
      return res.json()
    }
  })
}

export const getAllCostCenters = () => {
  return fetch(`${server_address}/api/v1/cost-center/view`, {
    headers: new Headers({
      'Authorization': `Bearer ${getAuthToken()}`
    }),
    method: 'GET'
  }).then((res) => {
     if (res.status === 401) {
      unAuthorizedToken()
    }
    else {
      return res.json()
    }
  })
}

export const getLedgerNames = () => {
  return fetch(`${server_address}/api/v1/ledger-names/ledgerNames`, {
    headers: new Headers({
      'Authorization': `Bearer ${getAuthToken()}`
    }),
    method: 'GET'
  }).then((res) => {
    if (res.status === 401) {
      unAuthorizedToken()
    }
    else {
      return res.json()
    }
  })
};

export const getRecoverableAmountPercentage = (ledgerNameId, centerId) => {
  return fetch(`${server_address}/api/v1/ledger-names/ledgerName/${ledgerNameId}/center/${centerId}`, {
    headers: new Headers({
      'Authorization': `Bearer ${getAuthToken()}`
    }),
    method: 'GET'
  }).then((res) => {
    if (res.status === 401) {
      unAuthorizedToken()
    }
    else {
      return res.json()
    }
  })
}

export const getLedgerIds = (ledgerNames) => {
  return fetch(`${server_address}/api/v1/ledger-names/ledgerIds`, {
    headers: new Headers({
      'Authorization': `Bearer ${getAuthToken()}`,
      "Content-Type": "application/json"
    }),
    method: 'POST',
    body: JSON.stringify(ledgerNames)
  }).then((res) => {
    if (res.status === 401) {
      unAuthorizedToken()
    }
    else {
      return res.json()
    }
  })
}

export const validateGSTN = (vendorCode, gstn) => {
  return fetch(`${server_address}/api/v1/payments/validateGSTN?gstn=${gstn}&vendorCode=${vendorCode}`, {
    headers: new Headers({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${getAuthToken()}`
    }),
    method: 'GET'
  }).then((res) => {
     if (res.status === 401) {
      unAuthorizedToken()
    }
    else {
      return res.json()
    }
  })
}

export const checkGstRcmApplicability = (ledgerNameId) => {
  return fetch(`${server_address}/api/v1/payments/gstRcmDetails/${ledgerNameId}`, {
    headers: new Headers({
      'Authorization': `Bearer ${getAuthToken()}`
    }),
    method: 'GET'
  }).then((res) => {
    if (res.status === 401) {
      unAuthorizedToken()
    }
    else {
      return res.json()
    }
  })
}

export const holdPaymentRequest = (body) => {
  return fetch(`${server_address}/api/v1/payments/payment-request/hold`, {
    headers: new Headers({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${getAuthToken()}`
    }),
    method: 'PUT',
    body: JSON.stringify(body)
  }).then((res) => {
    if (res.status === 401) {
      unAuthorizedToken()
    }
    else {
      return res.json()
    }
  })
}

export const handleAccountingStatus = (body) => {
  return fetch(`${server_address}/api/v1/payments/update/accounting-status`, {
    headers: new Headers({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${getAuthToken()}`
    }),
    method: 'POST',
    body: JSON.stringify(body)
  }).then((res) => {
    if (res.status === 401) {
      unAuthorizedToken()
    } else {
      return res.json()
    }
  })
}

export const getAllRecoverableAmountMappings = () => {
  return fetch(`${server_address}/api/v1/ledger-names/recoverableAmountMappings`, {
    headers: new Headers({
      'Authorization': `Bearer ${getAuthToken()}`
    }),
    method: 'GET'
  }).then((res) => {
    if (res.status === 401) {
      unAuthorizedToken()
    } else {
      return res.json()
    }
  })
}

export const createRecoverableAmountMapping = (body) => {
  return fetch(`${server_address}/api/v1/ledger-names/recoverableAmountMapping`, {
    headers: new Headers({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${getAuthToken()}`
    }),
    method: 'POST',
    body: JSON.stringify(body)
  }).then((res) => {
    if (res.status === 401) {
      unAuthorizedToken()
    } else {
      return res.json()
    }
  })
}

export const updateRecoverableAmountMapping = (id, body) => {
  return fetch(`${server_address}/api/v1/ledger-names/recoverableAmountMapping/${id}`, {
    headers: new Headers({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${getAuthToken()}`
    }),
    method: 'PUT',
    body: JSON.stringify(body)
  }).then((res) => {
    if (res.status === 401) {
      unAuthorizedToken()
    } else {
      return res.json()
    }
  })
}

export const deleteRecoverableAmountMapping = (id) => {
  return fetch(`${server_address}/api/v1/ledger-names/recoverableAmountMapping/${id}`, {
    headers: new Headers({
      'Authorization': `Bearer ${getAuthToken()}`
    }),
    method: 'DELETE'
  }).then((res) => {
    if (res.status === 401) {
      unAuthorizedToken()
    } else {
      return res.json()
    }
  })
}

export const createDateRangeMapping = (body) => {
  return fetch(`${server_address}/api/v1/ledger-names/recoverableAmountMapping/dateRange`, {
    headers: new Headers({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${localStorage.getItem('jwt_token_zaps')}`
    }),
    method: 'POST',
    body: JSON.stringify(body)
  }).then((res) => {
    if (res.status === 401) {
      unAuthorizedToken()
    } else {
      return res.json()
    }
  })
}

export const updateDateRangeMapping = (id, body) => {
  return fetch(`${server_address}/api/v1/ledger-names/recoverableAmountMapping/dateRange/${id}`, {
    headers: new Headers({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${localStorage.getItem('jwt_token_zaps')}`
    }),
    method: 'PUT',
    body: JSON.stringify(body)
  }).then((res) => {
    if (res.status === 401) {
      unAuthorizedToken()
    } else {
      return res.json()
    }
  })
}

export const deleteDateRangeMapping = (id) => {
  return fetch(`${server_address}/api/v1/ledger-names/recoverableAmountMapping/dateRange/${id}`, {
    headers: new Headers({
      'Authorization': `Bearer ${localStorage.getItem('jwt_token_zaps')}`
    }),
    method: 'DELETE'
  }).then((res) => {
    if (res.status === 401) {
      unAuthorizedToken()
    } else {
      return res.json()
    }
  })
}


// WEBPACK FOOTER //
// ./src/utils/PaymentRequestApiUtils.js